import { createListenerMiddleware, addListener, ListenerEffect, UnknownAction } from "@reduxjs/toolkit";
import type { TypedStartListening, TypedAddListener } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "@/store";
import { addCanvasCopiedToClipboardListener } from "./listeners/canvasCopiedToClipboard";
import { addCanvasDownloadedAsImageListener } from "./listeners/canvasDownloadedAsImage";
import { addRefreshGenListener } from "./listeners/refreshGenCoin";



export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening = listenerMiddleware.startListening as AppStartListening;

export const addAppListener = addListener as TypedAddListener<RootState, AppDispatch>;

export type AppListenerEffect = ListenerEffect<UnknownAction, RootState, AppDispatch>;


//如下写listener初始化
addCanvasCopiedToClipboardListener()
addCanvasDownloadedAsImageListener()
addRefreshGenListener()